import React from 'react';
import Icon from '../../../components/AppIcon';

const ChatSidebar = ({ conversations, activeConversationId, onSelectConversation, userRole, isMobileOpen, onMobileClose }) => {
  const getOtherParty = (conversation) => {
    return userRole === 'student' ? conversation?.institute : conversation?.student;
  };

  const getLastMessageTime = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return date?.toLocaleDateString();
  };

  return (
    <>
      {isMobileOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={onMobileClose}
        />
      )}
      <div
        className={`
          fixed lg:relative inset-y-0 left-0 z-50 lg:z-0
          w-80 lg:w-96 bg-card border-r border-border
          transform transition-transform duration-300 ease-in-out
          ${isMobileOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
        `}
      >
        <div className="h-full flex flex-col">
          <div className="p-4 border-b border-border flex items-center justify-between">
            <h2 className="text-lg font-semibold text-foreground">Messages</h2>
            <button
              onClick={onMobileClose}
              className="lg:hidden p-2 hover:bg-muted rounded-lg transition-smooth"
            >
              <Icon name="X" size={20} color="var(--color-foreground)" />
            </button>
          </div>

          <div className="flex-1 overflow-y-auto">
            {conversations?.length === 0 ? (
              <div className="p-8 text-center">
                <Icon name="MessageSquare" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-4" />
                <p className="text-muted-foreground">No conversations yet</p>
              </div>
            ) : (
              conversations?.map((conversation) => {
                const otherParty = getOtherParty(conversation);
                const isActive = conversation?.id === activeConversationId;

                return (
                  <button
                    key={conversation?.id}
                    onClick={() => {
                      onSelectConversation(conversation?.id);
                      onMobileClose();
                    }}
                    className={`
                      w-full p-4 flex items-start gap-3 hover:bg-muted transition-smooth
                      ${isActive ? 'bg-muted border-l-4 border-primary' : ''}
                    `}
                  >
                    <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                      <Icon name="Building2" size={24} color="var(--color-primary)" />
                    </div>
                    <div className="flex-1 min-w-0 text-left">
                      <div className="flex items-center justify-between mb-1">
                        <h3 className="font-medium text-foreground truncate">
                          {otherParty?.name || 'Unknown'}
                        </h3>
                        <span className="text-xs text-muted-foreground flex-shrink-0 ml-2">
                          {getLastMessageTime(conversation?.lastMessageAt)}
                        </span>
                      </div>
                      <p className="text-sm text-muted-foreground truncate">
                        {otherParty?.email || ''}
                      </p>
                    </div>
                  </button>
                );
              })
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ChatSidebar;